function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Placeholder, Action, AuthoringEffect, Options } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
var effects = ["Fire1", "Fire2", "Fire3", "Fire4", "Smoke", "Smoke2"]; // エフェクト追加モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
})(Mode || (Mode = {}));
/**
 * エフェクト追加モーダルコンポーネント
 */


var SessionAuthoringEffectModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionAuthoringEffectModalComponent, _React$Component);

  var _super = _createSuper(SessionAuthoringEffectModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionAuthoringEffectModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionAuthoringEffectModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          Name: "",
          Effect: "",
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    return _this;
  }
  /**
   * エフェクト名を更新します。
   *
   * @param e イベント
   */


  _createClass(SessionAuthoringEffectModalComponent, [{
    key: "updateName",
    value: function updateName(e) {
      this.setState({
        Name: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * エフェクト名を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEffect",
    value: function updateEffect(e) {
      this.setState({
        Effect: e.target.value
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      var _this2 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.Effect == null || this.state.Effect == "") {
          this.state.ErrorMessages.push(intl.format(Errors.DataNotSelected, {
            title: intl.format(Label.Effect)
          }));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var materialFileName = this.state.Name + "." + this.state.Effect;
        this.props.onEntry(materialFileName, function () {
          if (_this2.state.Modal == null) {
            throw Error();
          }

          _this2.state.Modal.modal('hide');
        });
      }
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#SessionAuthoringEffectDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringEffectDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_Effect_Gray.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringEffect.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Name"
      }, intl.format(Label.Name)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Name",
        id: "Name",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this4.updateName(e);
        },
        value: this.state.Name,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Name",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Effect"
      }, intl.format(Label.Effect)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "AuthorityId",
        name: "Effect",
        onChange: function onChange(e) {
          return _this4.updateEffect(e);
        },
        value: this.state.Effect,
        tabIndex: 102
      }, /*#__PURE__*/React.createElement("option", {
        className: "placeholder"
      }, intl.format(Options.Select)), effects.map(function (y, j) {
        return /*#__PURE__*/React.createElement("option", {
          value: y
        }, y);
      }))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry))))));
    }
  }]);

  return SessionAuthoringEffectModalComponent;
}(React.Component);

export { SessionAuthoringEffectModalComponent as default };